import $ from "jquery";
window.$ = window.jQuery = $;

require('./plugins/fade');

import './bootstrap';
import './FrontMain';
import './Home';
import './Us';
